import React from 'react';
import { ReactComponent as P } from '../../icons/plus.svg';
import { ReactComponent as M } from '../../icons/minus.svg';
import { ReactComponent as R } from '../../icons/zoom_reset.svg';
import styled from 'styled-components';

export const UICont = styled.div`
  position: fixed
  right: 1rem;
  z-index: 19;
  top: calc(50vh - 90px);
`;
export const El = styled.div`
	clear: both;
	margin-bottom: 0.5rem;
	cursor: pointer;
`;

const ZoomControl = ({ s, zoomSet, reset, mobile }) => {
	const zoom = s.level * s.zoomInit;
	const x = s.size.width - 64;
	let y = s.size.height / 2;
	return (
		<UICont id="UI-Zoom" className="control">
			{!mobile && (
				<El>
					<R className="icon reset" x={x} y={y - 48} onClick={reset} opacity={1} />
				</El>
			)}

			<El>
				<P
					className="icon plus"
					x={x}
					y={y + 3 * 8}
					onClick={zoom < 5000 ? () => zoomSet(s.level * 2.0) : undefined}
					opacity={zoom < 5000 ? 1 : 0.3}
				/>
			</El>
			<El>
				<M
					className="icon minus"
					x={x}
					y={y + 48 + 4 * +8}
					onClick={s.level >= 2 ? () => zoomSet(s.level / 2.0) : undefined}
					opacity={s.level >= 2 ? 1 : 0.3}
				/>
			</El>
		</UICont>
	);
};

export default ZoomControl;
